<template>
  <modal :is-active="isActive" :title="$t('configurator.modals.titles.article_description')">
    <template #body>
      <div>
        <div class="pc-print">
          <div>
            <img :src="previewImage" alt="" class="pc-print__image">
          </div>
          <div class="pc-print__body pc-print__body--description">
            <span class="pc-print__title">{{ name }}</span>
            <article>{{ description }}</article>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button class="btn btn-warning" @click="close">
          {{ $t('configurator.buttons.close') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script setup>
import { ARTICLE_DEFAULT_IMAGE } from '@/constants'
import { useMainStore } from '@/store'
import { computed } from 'vue'

const store = useMainStore()
// define props
const props = defineProps({
  article: {
    type: Object,
    required: true
  },
  isActive: {
    type: Boolean,
    default: true
  }
})
// define emits
const emit = defineEmits(['close'])
// define computed props
const locale = computed(() => store.settings.locale)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const hasImage = computed(() => {
  if (props.article.images === null) {
    return false
  }

  return props.article.images.length > 0
})

const previewImage = computed(() => {
  if (!hasImage.value) {
    return ARTICLE_DEFAULT_IMAGE
  }

  return '/images/articles/' + props.article.images[0].path;
})

const name = computed(() => {
  return (inEnglish.value) ? props.article.name_en : props.article.name
})

const description = computed(() => {
  return (inEnglish.value) ? props.article.description_en : props.article.description
})
// define methods
const close = () => emit('close')
</script>